export default __webpack_public_path__ + "static/media/google-play.0bc277f8.svg";